import axios from "axios";
// baseURL: "http://support.acsenteret.no:441",
export default axios.create({
  // baseURL: "https://support.acsenteret.no:443",
  headers: {
    "Content-type": "application/json",
  },
});
